"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));

var _app = require("@package/app");

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _defaultModule = _interopRequireDefault(require("./default.module.scss"));

var _excluded = ["children", "isActive", "onClick"];

function Merchants(_ref) {
  var children = _ref.children,
      isActive = _ref.isActive,
      onClick = _ref.onClick,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);

  try {
    var merchantClassName = (0, _react.useMemo)(function () {
      return (0, _classnames["default"])(_defaultModule["default"]['wrapper'], (0, _defineProperty2["default"])({}, _defaultModule["default"]['active'], isActive));
    }, [isActive]);
    var iconClassName = (0, _react.useMemo)(function () {
      return (0, _classnames["default"])(_defaultModule["default"]['icon'], 'icon-user', (0, _defineProperty2["default"])({}, _defaultModule["default"]['active'], isActive));
    }, [isActive]);
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: merchantClassName,
      "data-locator": props['data-locator'],
      onClick: onClick
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['logo']
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: iconClassName,
      "data-locator": props['data-locator'] + '.icon'
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['content']
    }, /*#__PURE__*/_react["default"].createElement("div", {
      "data-locator": props['data-locator'] + '.value',
      className: _defaultModule["default"]['name']
    }, children)));
  } catch (e) {
    return /*#__PURE__*/_react["default"].createElement(_app.Error, {
      error: e
    });
  }
}

var _default = /*#__PURE__*/_react["default"].memo(Merchants);

exports["default"] = _default;